// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"36083c8d","302":"bb4f23a9","424":"2c68fd34","493":"488c1929","589":"a266b943","692":"51292caa","962":"5d0df802","994":"6a0e1f8e"}[chunkId] + ".chunk.js";
};